<script lang="ts">
  import VideoPlayer from 'svelte-video-player';
  import { getJoodMembershipBasedPropertyValue, isMobileWidth } from '../../../common/util';
  import ImageTag from '../../common/lazy-components/ImageTag.svelte';
  import { getDataFromAmplienceAsync, parseImageVideoBannerData } from '../../common/services/amplience';

  export let metaData;

  let imageBannerData: {
    image?: string | null;
    mobileImage?: string | null;
    link?: string | null;
    bannerName?: string | null;
    bannerId?: string | null;
    video?: string | null;
    mobileVideo?: string | null;
  } | null = null;

  let loaded = false;

  const isResponsive = isMobileWidth();

  export async function onLoad() {
    loaded = false;
    imageBannerData = null;

    try {
      const amplienceId = getJoodMembershipBasedPropertyValue(
        metaData,
        'amplienceId',
        'blueAmplienceId',
        'goldAmplienceId'
      );

      if (!amplienceId) {
        return false;
      }

      const response = await getDataFromAmplienceAsync(amplienceId);

      const parsed = parseImageVideoBannerData(response);

      if (!parsed) {
        return false;
      }

      imageBannerData = parsed;
      loaded = true;
      return true;
    } catch (error) {
      console.error('[Banner] Load failed:', error);
      return false;
    }
  }

  $: bannerImage = isResponsive ? imageBannerData?.mobileImage : imageBannerData?.image;

  $: bannerVideo = isResponsive ? imageBannerData?.mobileVideo : imageBannerData?.video;

  $: shouldRenderVideo = !!bannerVideo;
  $: shouldRenderImage = !shouldRenderVideo && !!bannerImage;
</script>

{#if loaded && imageBannerData}
  <a href={imageBannerData.link || '#'} class="banner-wrapper">
    {#if shouldRenderImage}
      <!-- <img class="banner-image" src={bannerImage} alt={imageBannerData.bannerName || 'banner'} loading="lazy" /> -->
      <ImageTag
        imageUrls={[imageBannerData?.mobileImage, imageBannerData?.image]}
        widths={[430, 1440]}
        heights={[430, 300]}
        alt="1x1 banner"
      />
    {:else if shouldRenderVideo}
      <!-- <video class="banner-video" autoplay muted loop playsinline preload="metadata">
        <source src={bannerVideo} type={bannerVideo.includes('mp4') ? 'video/mp4' : 'video/webm'} />
      </video> -->
      {@const source = [
        bannerVideo + '/webm_480p',
        bannerVideo + '/mp4_480p',
        bannerVideo + '/webm_1080p',
        bannerVideo + '/mp4_1080p',
      ]}
      <VideoPlayer poster={bannerVideo} {source} iconColor="#fff" color="#2b333fb3" />
    {/if}
  </a>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .banner-wrapper {
    display: block;
    width: 100%;
    position: relative;
    overflow: hidden;
  }

  .banner-image,
  .banner-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>
